import { sleep } from "./utils";
import { map, max, range, shuffle } from "lodash";

declare const jQuery: any;
const $ = jQuery;

export function initTileLinks(): void
{
    const globalTileData = window["iw"].hsLinkTiles;
    if (!globalTileData)
    {
        return;
    }

    // Config ---------------------------------------------------------------------------
    const wait: number = 3000;
    const fadeEstimate: number = 2000; // keep syncd with _hs-link-tiles.scss value
    const waitBetweenTransitions: number = 800;
    // ----------------------------------------------------------------------------------

    const getTileDataSlice = (tileData: string[], tileIndex: number, numDisplayTiles: number): string[] => {
        let tileDataSlice: string[] = tileData.slice(tileIndex, tileIndex + numDisplayTiles);
        let numRemaining: number = numDisplayTiles - tileDataSlice.length;
        while (numRemaining > 0)
        {
            tileDataSlice = tileDataSlice.concat(tileData.slice(0, numRemaining));
            numRemaining = numDisplayTiles - tileDataSlice.length;
        }
        return tileDataSlice;
    };

    $(".hs-link-tiles").each(function () {
        const $wrap = $(this);
        const id: string = $wrap.attr("id");
        const tileData: string[] = globalTileData[id];
        if (!tileData || !tileData.length)
        {
            return;
        }
        const numTilesTotal: number = tileData.length;
        const $lis = $wrap.find("li");
        const numDisplayTiles: number = $lis.length;
        if (numTilesTotal <= numDisplayTiles)
        {
            return;
        }
        
        let tileIndex = 0;
        const incrementTileIndex = () => {
            tileIndex += numDisplayTiles;
            const over: number = tileIndex - numTilesTotal;
            if (over >= 0)
            {
                tileIndex = over;
            }
        };
        const waitThenNext = async () => {
            await sleep(wait);
            next();
        };
        const timerDurations: number[] = map(range(0, numTilesTotal), (index: number) => (index + 1) * waitBetweenTransitions);
        const greatestTimerDuration: number = max(timerDurations);
        const next = () => {
            incrementTileIndex();
            $lis.children().css({ zIndex: "" });
            const tileDataSlice: string[] = getTileDataSlice(tileData, tileIndex, numDisplayTiles);
            const newTiles: any[] = map(tileDataSlice, (html: string) => $(html).css({ zIndex: 10, opacity: 0 }));
            const randomTimerDurations: number[] = shuffle(timerDurations);
            $lis.each(async function (index: number) {
                const timerDuration: number = randomTimerDurations[index];
                await sleep(timerDuration);
                const $li = $(this);
                const $oldTile = $li.children();
                const $newTile = newTiles[index];
                $li.append($newTile);
                setTimeout(() => {
                    $newTile.css({ opacity: 1 });
                }, 20);
                setTimeout(() => {
                    $oldTile.remove();
                    if (greatestTimerDuration === timerDuration)
                    {
                        waitThenNext();
                    }
                }, fadeEstimate);
            });
        };
        waitThenNext();
    });
}
